import * as React from 'react';
import { ICardDateProps } from './types';
import './_CardDates.scss';
import * as moment from 'moment';
import {
    DATE_FORMAT_INDICATOR,
    DATE_FORMAT_TOOLTIP,
    DUE_DATE_ICON,
    OVERDUE_ICON,
    OVERDUE_MODIFIER,
    START_DATE_ICON
} from '../../../CardDateTimeIndicator/constants';
import { DUE_DATE_TOOLTIP_PREFIX, START_DATE_TOOLTIP } from '../../../../wording';
import { DONE_PROCESSING_STATUS } from '../../../Card/components/Card/constants';
import { Button, ButtonDropdown, Icon } from 'kui';
import { DatepickerHOC } from '../../../../../../base/components/Datepicker/hocs/DatepickerHOC/DatepickerHOC';
import {
    CARD_DUE_DATE,
    CARD_START_DATE,
    CARD_START_DATE_MILESTONE
} from '../../../../../../aside_panel/cardDetails/DatesSection/components/CardDatesSection/constants';
import {
    CARD_ACTIONS_PORTAL,
    CARD_CLASS,
    CARD_CONTROL_CLASS,
    CARD_TEMPLATES_PORTAL, DEFAULT_PORTAL,
    LIST_CONTAINER_CLASS, LIST_CONTROL_CLASS
} from '../../../../constants';
import { EDateType } from '../../../../../../../../const';
import { getParentsClasses } from '../../../../../../helpers/getParentsClasses';
import { v4 as uuidv4 } from 'uuid';
import { NewCardDateTimeIndicator } from '../NewCardDateTimeIndicator/NewCardDateTimeIndicator';
import { CLASS_ABSTRACT_DASHBOARD_SCROLL_PREVENT } from '../../../../../../../abstracts/constants';
import { CLASS_DATEPICKER } from '../../../../../../base/components/Datepicker/components/constants';
import { TOP_BAR_CLASS } from '../../../../../topBar/constants';
import { root } from 'app/store/constants';
import { AnalyzeRender } from 'app/view/react_components/helpers/memoizeHelper';
import * as _ from 'underscore';

const analyzeRender = root.Settings.development ? new AnalyzeRender(`CardDates`) : null;

export function CardDates({
    cardId,
    defaultDueTime,
    defaultStartTime,
    dueDate,
    isDisabled,
    isHideIcons,
    isOpened,
    isMilestone,
    isReadonly,
    isShowDue = true,
    isShowStart = true,
    isTemplates,
    listId,
    processingStatus,
    startDate,
    onChange,
    setDatesOpened,
    onOpen,
    onShowSnackbar,
    setOpen,
}: ICardDateProps) {
    if (isDisabled && !dueDate && !startDate) return null;

    // const debugProps = React.useRef(null);
    // React.useEffect(() => {
    //     const oldProps = debugProps.current;
    //     const newProps = {
    //         cardId,
    //         defaultDueTime,
    //         defaultStartTime,
    //         dueDate,
    //         isDisabled,
    //         isHideIcons,
    //         isOpened,
    //         isMilestone,
    //         isReadonly,
    //         isShowDue,
    //         isShowStart,
    //         isTemplates,
    //         listId,
    //         processingStatus,
    //         startDate,
    //         onChange,
    //         onDatesClose,
    //         onOpen,
    //         onShowSnackbar,
    //         setOpen
    //     };
    //     const diff = {};
    //     if (oldProps) {
    //         Object.keys(oldProps).forEach((key) => {
    //             // @ts-ignore
    //             if (oldProps[key] !== newProps[key]) {
    //                 // @ts-ignore
    //                 diff[key] = { from: oldProps[key], to: newProps[key]};
    //             }
    //         });
    //     }
    //     if (!_.isEmpty(diff)){
    //         console.log(cardId, diff);
    //     }
    //     debugProps.current = newProps;
    // });

    if (analyzeRender) analyzeRender.call(cardId, arguments[0]);

    const className = CARD_CLASS + '__dates';
    const [classUnique] = React.useState(className + '--' + uuidv4());
    const classButton = className + '-button';
    const classDate = className + '-button-date';
    const classStart = classDate + '--start';
    const classDue = classDate + '--due';

    const momentStartDate = moment(startDate);
    const startText = momentStartDate.format(DATE_FORMAT_INDICATOR);
    const startTooltip = START_DATE_TOOLTIP + momentStartDate.format(DATE_FORMAT_TOOLTIP);

    const momentDueDate = moment(dueDate);
    const dueText = momentDueDate.format(DATE_FORMAT_INDICATOR);
    const dueTooltip = DUE_DATE_TOOLTIP_PREFIX + momentDueDate.format(DATE_FORMAT_TOOLTIP);
    const isOverdue = moment() > momentDueDate;
    const dueIcon = isOverdue ? OVERDUE_ICON : DUE_DATE_ICON;
    const modifier = isOverdue && processingStatus !== DONE_PROCESSING_STATUS ? OVERDUE_MODIFIER : '';

    let [openedProperty, setOpenedProperty] = React.useState(isShowStart && !isShowDue ? EDateType.START_DATE : EDateType.DUE_DATE);
    const [_isOpened, _setOpened] = React.useState(null);

    const setOpened = (isOpen: boolean) => {
        _setOpened(isOpen);
        if (isOpen) setOpen(isOpen);
    }

    const onClick = (e: React.SyntheticEvent) => {
        if (!startDate && !dueDate) return;
        const parentClasses = getParentsClasses(e.target as HTMLElement, [
            classUnique
        ]);
        if (parentClasses.includes(classStart) && (_isOpened ? openedProperty !== EDateType.START_DATE : true)) {
            setOpenedProperty(EDateType.START_DATE);
            setTimeout(() => {
                setOpened(true);
            }, 100);
        }
        if (parentClasses.includes(classDue) && (_isOpened ? openedProperty !== EDateType.DUE_DATE : true)) {
            setOpenedProperty(EDateType.DUE_DATE);
            setTimeout(() => {
                setOpened(true);
            }, 100);
        }
    };

    React.useEffect(() => {
        if (isOpened) {
            setTimeout(() => {
                setOpened(isOpened);
            }, 0);
        }
    }, [isOpened]);

    React.useEffect(() => {
        const list = document.querySelector('.' + LIST_CONTAINER_CLASS + '[data-rbd-draggable-id="' + listId + '"]') as HTMLElement;
        if (!list) return;
        if (_isOpened) {
            list.classList.add(LIST_CONTAINER_CLASS + '--with-opened-actions');
        } else {
            list.classList.remove(LIST_CONTAINER_CLASS + '--with-opened-actions');
        }
        function onScroll() {
            setOpened(false)
        }
        if (_isOpened && !isTemplates) {
            window.addEventListener('scroll', onScroll);
        }

        return () => window.removeEventListener('scroll', onScroll);
    }, [_isOpened]);

    return (
        <div
            className={`${className + '-wrapper'} ${CARD_CONTROL_CLASS}` }
            onClick={() => {if (isDisabled && !isReadonly) onShowSnackbar()}}
        >
            <ButtonDropdown
                className={`
                    ${className}
                    ${classUnique}
                    ${EDateType.START_DATE === openedProperty && _isOpened ? className + '--start' : ''}
                    ${EDateType.DUE_DATE === openedProperty && _isOpened ? className + '--due' : ''}
                    ${isHideIcons ? className + '--hide-icons' : ''}
                    ${isDisabled ? className + '--disabled' : ''}
                `}
                dropdownClassName={`
                    ${CARD_CONTROL_CLASS}
                    ${className + '-dropdown'}
                    ${CLASS_ABSTRACT_DASHBOARD_SCROLL_PREVENT}
                    ${LIST_CONTROL_CLASS}
                `}
                notBlurClasses={[
                    'custom-datepicker__calendar',
                    'custom-datepicker__calendar-select-dropdown',
                ]}
                onClick={onClick}
                onOpen={() => {
                    const topBar = document.querySelector(`.${TOP_BAR_CLASS}`) as HTMLElement;
                    if (topBar) {
                        topBar.style.zIndex = 'unset';
                    }
                    onOpen();
                    setOpened(true);
                    setTimeout(() => {
                        const dropdown = document.querySelector(`
                            .${className}-dropdown
                            .${CLASS_DATEPICKER}__item--${openedProperty === EDateType.DUE_DATE ? 'to' : 'from'}
                            .${ CLASS_DATEPICKER}__date-button-create
                        `) as HTMLElement;
                        if (dropdown) dropdown.focus();
                    }, 100);
                }}
                onClose={() => {
                    setOpened(false);
                    setDatesOpened(false);
                    const topBar = document.querySelector(`.${TOP_BAR_CLASS}`) as HTMLElement;
                    if (topBar) {
                        topBar.style.zIndex = '120'; // $z-fold * 1.2
                    }
                }}
                opened={_isOpened}
                portal
                portalId={isTemplates ? CARD_TEMPLATES_PORTAL : DEFAULT_PORTAL}
                disabled={isReadonly}
            >
                <Button
                    className={`
                        ${classButton}
                        ${startDate || dueDate ? classButton + '--active' : ''}
                    `}
                    variant={'icon'}
                >
                    {
                        (
                            !startDate && !dueDate ||
                            !isShowStart && !!startDate && !dueDate ||
                            !isShowDue && !!dueDate && !startDate
                        ) &&
                        <Icon xlink={'calendar'} size={16} />
                    }
                    {isShowStart && !!startDate &&
                        <NewCardDateTimeIndicator
                            tooltip={startTooltip}
                            text={startText}
                            icon={START_DATE_ICON}
                            className={`${classDate} ${classStart}`}
                            isAction
                        />
                    }
                    {isShowDue && !!dueDate &&
                        <NewCardDateTimeIndicator
                            tooltip={dueTooltip}
                            text={dueText}
                            icon={dueIcon}
                            modifier={modifier}
                            className={`${classDate} ${classDue}`}
                            isAction
                        />
                    }
                </Button>
                <DatepickerHOC
                    className={className + '-picker'}
                    selectedToDate={dueDate && new Date(dueDate)}
                    selectedFromDate={startDate && new Date(startDate)}
                    onChange={onChange}
                    isSingle={isMilestone}
                    fromPlaceholder={isMilestone ? CARD_START_DATE_MILESTONE : CARD_START_DATE}
                    toPlaceholder={CARD_DUE_DATE}
                    isFromDisabled={isDisabled}
                    defaultFromTime={defaultStartTime}
                    defaultToTime={defaultDueTime}
                    isToDisabled={isDisabled}
                    isOverdue={isOverdue}
                    isToOpened={openedProperty === EDateType.DUE_DATE}
                    isFromOpened={openedProperty === EDateType.START_DATE}
                    isNoDropdown
                    isKeepTime
                    onToClick={() => setOpenedProperty(EDateType.DUE_DATE)}
                    onFromClick={() => setOpenedProperty(EDateType.START_DATE)}
                />
            </ButtonDropdown>
        </div>
    );
}
